import React, { useState } from 'react';
import { useStaffData } from '../../../context/StaffsDataContext';
import Form from 'react-bootstrap/Form';

//Initial Schedule
const initialFormData = {
  section:'', assessment_name:'', date_of_exam:''
};

const ScheduleMatrix = ({ subjectAssignment }) => {
    const classes = ['Nursery', 'KG-1', 'Class-1', 'Class-2', 'Class-3', 'Class-4', 'Class-5', 'Class-6', 'Class-7', 'Class-8', 'Class-9', 'Class-10'];
    const periods = ['Period-1', 'Period-2', 'Period-3', 'Period-4', 'Period-5', 'Period-6', 'Period-7'];

    //Initial Schedule
    //Get staff data
    const { staffData, refreshStaffData } = useStaffData();

    // Function to generate an empty matrix
    const generateEmptyMatrix = () => {
      const matrix = [];

      // Add rows for each class
      for (let i = 0; i < classes.length; i++) {
        const row = [];
        for (let j = 0; j < periods.length; j++) {
          row.push('');
        }
        matrix.push(row);
      }

      return matrix;
    };

    const [scheduleMatrix, setScheduleMatrix] = useState(generateEmptyMatrix());

    const handleSelectChange = (event, rowIndex, columnIndex) => {
      const updatedMatrix = [...scheduleMatrix];
      updatedMatrix[rowIndex][columnIndex] = event.target.value;
      setScheduleMatrix(updatedMatrix);
    };

    // console.log(scheduleMatrix);

    const reducedArray = subjectAssignment.reduce((result, item) => {
      const existingItem = result.find((x) => x.empcode === item.empcode && x.task_code === item.task_code);
  
      if (!existingItem) {
          result.push({
              taskId: item.taskId,
              empcode: item.empcode,
              teacher: item.teacher,
              task: item.task,
              task_code: item.task_code,
              alloted_section:item.alloted_section
          });
      }
  
      return result;
  }, []);

  const combinedArray = reducedArray.map(obj => {
    const teacherInitials = obj.teacher.split(" ").map(word => word.charAt(0)).join("");
    const last4Digits = obj.empcode.slice(-4);

    return {
        teacher: `${teacherInitials}-${last4Digits}`,
        task: `${obj.alloted_section}-${obj.task}`
    };
});
  
  // console.log(reducedArray);
  // console.log(combinedArray);

  const arrayOfObjects = scheduleMatrix.map(scheduleArray => {
    return scheduleArray.reduce((result, schedule, index) => {
        result.push({
            period: index + 1,
            task: schedule || "" // Set to an empty string if the schedule is falsy (e.g., an empty string in the original array)
        });
        return result;
    }, []);
});

console.log(arrayOfObjects);

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ borderCollapse: 'collapse', border: '1px solid black', width: '100%' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>Classes</th>
            {periods.map((period, index) => (
              <th key={index} style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{period}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {classes.map((className, rowIndex) => (
            <tr key={rowIndex}>
              <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{className}</td>
              {periods.map((period, columnIndex) => (
                <td key={columnIndex} style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  {/* <select value={scheduleMatrix[rowIndex][columnIndex]} onChange={(event) => handleSelectChange(event, rowIndex, columnIndex)}>
                    <option value="">Select Subject</option>
                    <option value="PP101">LK-PP101</option>
                    <option value="PP102">PKJ-SS101</option>
                  </select> */}
                  <select className="form-control" name="teacher_for_class"  size="lg" style={{width:'100%'}} value={scheduleMatrix[rowIndex][columnIndex]} onChange={(event) => handleSelectChange(event, rowIndex, columnIndex)}>
                    <option value="all">---All---</option>
                    {combinedArray.map((item, index) => 
                        <option value={`${item.task}-${item.teacher}`} key={index}>{item.task}-{item.teacher}</option>
                    )}
                  </select>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};



export default ScheduleMatrix;
